import {mapGetters, mapActions} from "vuex"
import {DRAWER_WIDTH} from "@/util/const"
import SortModel from "./models/candidatesSortModel"
import CandidateBroadcast from "./models/candidateBroadcast"
import { CANDIDATE_PAGE } from "./candidates-const"
import PaginationModel from "@/models/paginationModel"


export default {
  
  data: () => ({
    list: [],
    pagination: null,
    loading: false,
    primaryPagination: null,
    fullListIds: [],
    activeItems: [],
    selectedItem: null,
    sortModel: null,
    currentPage: null,
    sortBy: [],
    sorting: [],
    expanded: [],
  }),
  
  inject: ['svc'],
  
  computed:{ 
    ...mapGetters({
      drawerStatus: 'crmDrawer/value',
      labels: 'labels/items'
    }),
  
    actionPanelMarginRight() {
      if(!this.drawerStatus) return '24px'
      return (DRAWER_WIDTH + 24) + 'px'
    },

    showSelectAll() {
      return this.activeItems.length && this.pagination && this.pagination.count > this.pagination.size
    }
  },
  
  created() {
    this.init()
  },
  
  async mounted() {
    await this.setDefaultPagination()
    this.loadCandidateColors();
    this.loadData()
  },
  
  methods: {
    ...mapActions({
      getExamLocations: 'crmExamLocation/list',
      loadCandidateColors: 'crmCandidateColors/colorsList',
      getCbrUsers: 'cbrUser/list'
    }),
  
    init() {
      this.initSortModel()
      this.initCandidateBroadcast()
    },
  
    initSortModel() {
      this.sortModel = new SortModel(this.$route.query)
    },
  
    async initCandidateBroadcast() {
      let tokens
      tokens = await this.$auth.getTokensFromRepoOrRefresh()
      this.broadcast = new CandidateBroadcast(null, tokens.access)
      this.broadcast.startListen(this.getBroadcastData)
    },
  
    getBroadcastData() {
      return this.list
    },
  
    async loadData() {
      await Promise.all([
        this.loadList({}),
        this.getCbrUsers({cache: true})
      ])
    },
  
    async _loadList({more = false, page = CANDIDATE_PAGE.TASKS}) {
      this.currentPage = page;
      try {
        this.loading = true
        let { results, pagination, candidates_counts} = await this.svc().list(this.$route.query, page)
        this.pagination = new PaginationModel(this.setPaginationParams(pagination))
        if(more) this.list.push(...results)
        else {
          this.list = results
          this.setPrimaryPagination()
        } 
        this.loading = false
        this.$emit('candidatesCountsChanged', candidates_counts)
        this.clearFullListIds();
      } catch (error) {
        console.log(error)
        this.loading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }     
    },

    async toggleSelectAllItems({clear}) {
      if (clear) {
        this.activeItems = []
      } else {
        if (!this.fullListIds.length) {
          await this._loadList({page: this.currentPage})
          await this._getFullListIds();
        }
        this.activeItems = this.fullListIds;
      }
    },

    async _getFullListIds() {
      try {
        this.loading = true
        const res = await this.svc().fullListIds(
          {
            ids_list: true,
            ...this.$route.query
          },
          this.currentPage
        )
        this.fullListIds = res;
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      } 
    },
      
    setPrimaryPagination() {
      this.primaryPagination = {
        page: this.pagination.page,
        size: this.pagination.size
      }
    },
  
    async paginationChange() {
      await this.setPaginationQuery()
      this.loadList({})
    },
  
    async onLoadMoreClick() {
      this.pagination.loadMore()
      await this.setPaginationQuery()
      this.loadList({more: true})
    },
  
    async setPaginationQuery() {
      await this.$router.replace({query: {...this.$route.query, page: this.pagination.page, size: this.pagination.size }})
    },
  
    goToEdit({expand, isExpanded}) {
      if(this.$refs.expand) {
        if(this.$refs.expand.model.editing) {
          let goToEdit = () =>{
            setTimeout(() => {
              expand(!isExpanded)
            }, 0);
          } 
          this.$refs.expand.goBackHandler(goToEdit)
          return
        }
      }
      expand(!isExpanded)
    },
  
    hideExpandBy(ID) {
      let expandIndex = this.expanded.findIndex(item => item.ID === ID)
      if(expandIndex < 0) return
      this.expanded.splice(expandIndex, 1)
    },
  
    async markAsProcessed() {
      try {
        let ids = this.activeItems.map(item => item.ID)
        let res = await this.Svc().markAsProcessed(ids)
        this.loadList({})
        return res
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
        return Promise.reject(error)
      }
    },
  
    async updateSorting() {
      let data = this.sortModel.getApiData(this.$route.query)
      let ordering
      if(data.ordering.length) ordering = data.ordering
      await this.$router.replace({ query: { ...this.$route.query, ...this.getDefaultPagination(), ordering: ordering}})
      this.loadList({})
    },
  
    copyMultiple() {
      let activeItemsIndex = this.activeItems.map(item => this.list.findIndex(_item => _item.ID === item.ID))
        .sort((a, b) => a - b)
      let data = activeItemsIndex.map(index => this.list[index].getSpreadsheetData(this.$store))
      this.copy(data.join('\n'))
    },
  
    updateTableDataBy(item, candidate) {
      item.merge(candidate)
      // item.requests = candidate.requests
    },
  
    extendedSelection({item, index}) {
      let activeItemsIndex = this.activeItems.map(item => this.list.findIndex(_item => _item.ID === item.ID))
      let itemUpperToSelectedIndex = -1
      activeItemsIndex.forEach(activeIndex => {
        if((index > activeIndex) && (itemUpperToSelectedIndex < activeIndex)) itemUpperToSelectedIndex = activeIndex
      })
      if(itemUpperToSelectedIndex < 0) return
      for(let i = itemUpperToSelectedIndex + 1; i < index; i++) {
        this.activeItems.push(this.list[i])
      }
    },

    paymentsOpen(data) {
      this.$refs.payments.saveCandidateAndOpen(data)
    },

    updateActiveItemsHold(status) {
      this.activeItems.forEach(item => {
        item.requests.forEach(request => {
          request.onHold = status
        })
      })
    },

    clearFullListIds() {
      this.fullListIds = [];
    },
  },

  watch: {
    '$route.query': function() {
      this.activeItems = []
    }
  },
}